








import {
  Component,
  Vue,
} from 'vue-property-decorator';

import SystemMessagesWrapper from '@/components/SystemMessages/Wrapper.vue';
import {
  metaInfoHelper,
} from '@/utils/meta-info-helper';


@Component({
  name: 'App',
  components: {
    SystemMessagesWrapper,
  },
  metaInfo() {
    const title = metaInfoHelper.defaultTitle;

    return {
      title,
      titleTemplate: metaInfoHelper.titleTemplate,
      meta: [
        { name: 'description', content: metaInfoHelper.defaultDescription },
        ...metaInfoHelper.getHeaderOGMeta({ title }),
      ],
    };
  },
})
export default class App extends Vue {}
